import { Button } from '@synoptic/ui-kit/button/button.js';
import clsx from 'clsx';
import { Components } from 'react-virtuoso';
import {
  feedFloatingAction,
  feedFloatingActionContainer,
  feedFloatingActionXSmall,
} from './feed-scroller-with-floating-header.css';

export type FeedScrollerWithFloatingHeaderContext = {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
  compactFeed?: boolean;
} | null;

export const FeedScrollerWithFloatingHeader: Components<
  unknown,
  {
    floatingHeader?: FeedScrollerWithFloatingHeaderContext;
  }
>['Scroller'] = ({ context, children, ...props }) => {
  return (
    <div {...props}>
      {context?.floatingHeader ? (
        <div className={feedFloatingActionContainer}>
          <Button
            className={clsx(
              feedFloatingAction,
              context.floatingHeader.compactFeed && feedFloatingActionXSmall,
            )}
            rounded
            variant="secondary"
            size={context.floatingHeader.compactFeed ? 'xSmall' : 'small'}
            startIcon={context.floatingHeader.icon}
            onClick={context.floatingHeader.onClick}
          >
            {context.floatingHeader.title}
          </Button>
        </div>
      ) : null}

      {children}
    </div>
  );
};
